var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { DotLoader } from "syf-component-library/ui/atoms";
import { Stack } from "syf-component-library/ui/spacing";
import MultiAccountOptions from "./MultiAccountOptions";
import { useEditProfileContext } from "../../../../context/editProfileContext";
import anyBooleanIsTrue from "../../../../helpers/anyBooleanIsTrue";
import ProfileRow from "../../../molecules/ProfileRow";
import { RowInput } from "../../../subcomponents";
import ButtonContainer, { FullWidthButton } from "../subcomponents";
import { useProfileGlobalState } from "../../../../context/profileGlobalState";
import getTranslation from "../../../../strings/getTranslations";
var MultiAccountSection = function () {
    var t = getTranslation().t;
    var goToShowProfile = useProfileGlobalState().goToShowProfile;
    var _a = useEditProfileContext(), phoneRequiredError = _a.phoneRequiredError, accountsList = _a.accountsList, selectedAccounts = _a.selectedAccounts;
    var _b = useFormContext().formState, isSubmitting = _b.isSubmitting, isValid = _b.isValid, isValidating = _b.isValidating;
    var hasMultiAccounts = accountsList.length > 1;
    var _c = useState(false), isMultiAccountPicked = _c[0], setIsMultiAccountPicked = _c[1];
    var _d = useState(false), multiAccountToggle = _d[0], setMultiAccountToggle = _d[1];
    var triggerMultiAccountOption = function (status) {
        setMultiAccountToggle(status);
        setIsMultiAccountPicked(true);
    };
    return (_jsx(ProfileRow, __assign({ title: " " }, { children: _jsxs(RowInput, { children: [hasMultiAccounts && (_jsx(MultiAccountOptions, { multiAccountToggle: multiAccountToggle, isMultiAccountPicked: isMultiAccountPicked, triggerMultiAccountOption: triggerMultiAccountOption })), _jsx(Stack, { size: "xlarge" }), _jsx(Stack, { size: "xlarge" }), _jsxs(ButtonContainer, { children: [_jsx(Stack, { size: "small" }), _jsx(FullWidthButton, __assign({ order: 2, disabled: anyBooleanIsTrue(isSubmitting, !isValid, !isMultiAccountPicked && hasMultiAccounts, phoneRequiredError, multiAccountToggle && selectedAccounts.length <= 1), buttonType: "primary", type: "submit", "data-analytics": "clicktrackingevent", "data-type": "edit", "data-reason": "save changes", "data-cy": "saveChanges", "data-object": "button" }, { children: isSubmitting || isValidating ? (_jsx(DotLoader, {})) : (t("actions.saveChanges")) })), _jsx(FullWidthButton, __assign({ order: 1, buttonType: "ghost", type: "button", onClick: goToShowProfile, disabled: isSubmitting, "data-analytics": "clicktrackingevent", "data-type": "edit", "data-reason": "cancel", "data-cy": "cancelChanges", "data-object": "button" }, { children: t("actions.cancel") }))] })] }) })));
};
export default MultiAccountSection;
